import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-neutral-100" data-id="element-354" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-355" data-mp="cn7tv1a4qo2i">
        <div className="text-center mb-16" data-id="element-356" data-mp="7pemw6105q16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-neutral-900" data-id="element-357" data-mp="7qhdecuexqgk">
            THE COMPLETE 6-IN-1 HEAVY EQUIPMENT INSTRUCTOR <span className="text-amber-600" data-id="element-358" data-mp="3g2vc3h3oresi">ATLAS</span>{' '}
            SYSTEM
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-359" data-mp="3pv12imeaho5l">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-amber-500 shadow-lg shadow-neutral-900/10' : 'border-neutral-200 shadow-sm shadow-neutral-900/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-360" data-mp="3l4axxbdotpby" data-mpi={index}>
              {volume.popular && <div className="absolute top-7 right-[-44px] bg-yellow-400 text-neutral-900 font-bold text-xs py-1 px-10 rotate-45 shadow whitespace-nowrap" data-id="element-361" data-mp="2o33eedqmzn8g">
                  {volume.popularLabel ?? 'MOST POPULAR'}
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-362" data-mp="20etzlvrubzqt">
                <span className="w-12 h-12 rounded-xl bg-neutral-900 text-yellow-400 font-extrabold text-2xl flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-363" data-mp="20divtvyearzp">
                  {index + 1}
                </span>
                <div data-id="element-364" data-mp="3fu9it6de473j">
                  <div className="text-amber-700 font-bold text-sm uppercase tracking-wider" data-id="element-365" data-mp="3ftrgpt41qynp">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tight leading-tight mt-1 text-neutral-900" data-id="element-366" data-mp="1bsj2kn37f3ed">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-neutral-900 font-semibold mb-6 border-l-4 border-amber-500 pl-4" data-id="element-367" data-mp="1ks655c7o6f90">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-368" data-mp="t32wzlcnwkr3">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-neutral-800 text-sm leading-relaxed" data-id="element-369" data-mp="16upyq0pdilh9">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-370" data-mp="e9zk3ra0mv6p">
                      {volume.questions.map(question => <li key={question} className="text-neutral-900 font-semibold text-sm bg-neutral-50 border border-neutral-200 rounded-lg px-3 py-2" data-id="element-371" data-mp="2l0cjy7zagg9e">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-neutral-900 font-bold text-base bg-yellow-50 border-l-4 border-amber-500 rounded-lg px-4 py-3" data-id="element-372" data-mp="34pn01n2y5381">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-neutral-800 text-sm leading-relaxed" data-id="element-373" data-mp="2zpijxy5yaaic">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-374" data-mp="1j9o11efe92tn">
                <div data-id="element-375" data-mp="1jdljryy27sd0">
                  <p className="text-neutral-900 font-semibold text-sm mb-3" data-id="element-376" data-mp="1oa29gxkwqes7">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-377" data-mp="23jqksljf49bc">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-378" data-mp="1ptn1a2bxatpl">
                        <CheckCircle2 size={18} className="text-amber-500 shrink-0 mt-0.5" data-id="element-379" data-mp="2mjcsexl3gte3" />
                        <span className="text-neutral-800 text-sm" data-id="element-380" data-mp="2ihiyr99bgpnf">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-381" data-mp="28i0e0qll0zub">
                    <p className="text-neutral-900 font-semibold text-sm mb-3" data-id="element-382" data-mp="28ijus3zhxi6r">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-383" data-mp="x3ddezuso9qj">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-384" data-mp="mxvdxdm8gxte">
                          <CheckCircle2 size={18} className="text-amber-500 shrink-0 mt-0.5" data-id="element-385" data-mp="rzkn0npwb1eu" />
                          <span className="text-neutral-800 text-sm" data-id="element-386" data-mp="wwkvt6e4qi9n">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-387" data-mp="1ap134je2d2gd">
                  {volume.sequenceIntro && <p className="text-neutral-900 font-semibold text-sm mb-2" data-id="element-388" data-mp="1fond8jyli2ky">{volume.sequenceIntro}</p>}
                  <p className="text-neutral-900 font-bold text-sm bg-yellow-50 border border-neutral-200 rounded-lg px-3 py-2" data-id="element-389" data-mp="1ko01n9547hpn">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-neutral-50 border border-neutral-200 border-l-4 border-l-amber-500 rounded-xl p-4 mt-auto" data-id="element-390" data-mp="3mfmwxmw1hyrx">
                <span className="text-neutral-900 font-bold block mb-1" data-id="element-391" data-mp="3eghyqejyzhia">RESULT</span>
                {volume.resultLead && <p className="text-neutral-800 text-sm" data-id="element-392" data-mp="3ocbk8nfo2lc7">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-neutral-900" data-id="element-393" data-mp="3jcyx01kvvc93">{volume.resultQuote}</span>
                  </p>}
                <p className="text-neutral-800 text-sm" data-id="element-394" data-mp="16khvzavow94">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-extrabold tracking-tight text-amber-600" data-id="element-395" data-mp="3sdwtlyszshhn">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}